var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { atom } from 'jotai';
import apiClient from '../API/InkyAPI';
import { AccountInfoAtom } from './AccountStore';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from './AnalyticsStore';
import InkyAPI from '../API/InkyAPI';
import AnalyticsEvent from '../Models/Analytics/AnalyticsEvent';
var sendAnalyticsEvent = function (accountInfo, analyticsId, userProxy, query) {
    InkyAPI.sendEvent(accountInfo, new AnalyticsEvent(analyticsId.toString(), "SEARCH", location.pathname, query, userProxy))
        .then(function (res) { });
};
export default sendAnalyticsEvent;
var cancelSearch = null;
export var SearchResultLoadingStatus = atom(false);
export var SearchResultAtom = atom([]);
export var FetchSearchAtom = atom(function (get) {
    return get(SearchResultAtom);
}, function (get, set, query) { return __awaiter(void 0, void 0, void 0, function () {
    var accountInfo_1, analyticsId_1, userProxy_1, res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                if (cancelSearch !== null) {
                    cancelSearch.cancel();
                }
                accountInfo_1 = get(AccountInfoAtom);
                analyticsId_1 = get(AnalyticsIdAtom).toString();
                userProxy_1 = get(AnalyticsUserProxyAtom);
                console.log('searching for: ' + query);
                set(SearchResultLoadingStatus, true);
                return [4 /*yield*/, apiClient.searchAndCancel(query, null)];
            case 1:
                res = _a.sent();
                cancelSearch = res.controller;
                res.res.then(function (result) {
                    sendAnalyticsEvent(accountInfo_1, analyticsId_1, userProxy_1, query);
                    console.log('res', result);
                    set(SearchResultLoadingStatus, false);
                    set(SearchResultAtom, result.response);
                    return result;
                });
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                console.error('[SearchStore] Could not fetch Search-data: ' + e_1.message, e_1);
                set(SearchResultLoadingStatus, false);
                throw e_1;
            case 3: return [2 /*return*/];
        }
    });
}); });
export var SearchQueryAtom = atom('');
export var FetchSearchQueryAtom = atom(function (get) {
    return get(SearchQueryAtom);
}, function (get, set, query) { return __awaiter(void 0, void 0, void 0, function () {
    var queryString;
    return __generator(this, function (_a) {
        queryString = get(SearchQueryAtom);
        try {
            queryString = query;
            set(SearchQueryAtom, queryString);
        }
        catch (e) {
            console.error('[SearchStore] Could not fetch Search Query ' + e.message, e);
            throw e;
        }
        return [2 /*return*/];
    });
}); });
